import { setLogOut } from 'entities/auth';
import { store } from '../../app/store';
import { BASE_URL } from '../conf/constants';

const fetchWithAuth = async (url: string, options?: RequestInit): Promise<Response> => {
  const token = localStorage.getItem('access_token') || '';
  const headers = new Headers(options?.headers);
  headers.set('Authorization', `Bearer ${token}`);

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 403) {
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) {
      store.dispatch(setLogOut());
      return response; // Return the 403 response
    }

    const refreshResponse = await fetch(`${BASE_URL}/account/admin/login/refresh-token`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    if (refreshResponse.status === 200) {
      const { access_token, refresh_token } = await refreshResponse.json();
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);

      // Retry the original request with the new token
      const newToken = access_token;
      const newHeaders = new Headers(options?.headers);
      newHeaders.set('Authorization', `Bearer ${newToken}`);

      const originalRequest = new Request(url, {
        ...options,
        headers: newHeaders as any, // Cast to any to satisfy RequestInit headers type
      });

      return fetch(originalRequest);
    }
    if (refreshResponse.status === 401) {
      store.dispatch(setLogOut());
      return refreshResponse; // Return the 401 response from refresh
    }
  }

  return response;
};

export default fetchWithAuth;
